import { defineComponent as _defineComponent } from 'vue'
import { ComputedRef, computed, useStore } from "@nuxtjs/composition-api";

import { useI18n } from "@/composables";
import { getProductDetailsStore } from "@/store/product-details";
import { getProductsStore } from "@/store/products";
import { Actions } from "@/utils/snowplow/enums";
import { createProductImpression } from "@/utils/snowplow/factory";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFeedItem',
  props: {
  productId: { type: String, required: true },
  profileId: { type: String, required: true },
  position: { type: Number, required: false, default: null },
  height: { type: [String, Number], required: true },
  width: { type: [String, Number], required: true },
  isSearch: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



const i18n = useI18n();
const store = useStore();
const productsStore = getProductsStore(store);
const productDetailsStore = getProductDetailsStore(store);

const product = computed(() => productsStore.products[props.productId]);
const productDetails = computed(() => productDetailsStore.productDetails[product.value?.productDetailsId ?? ""]);
const productImage = computed(() => product.value?.imageUrl);
const productName = computed(() => productDetails.value?.name);
const productUrl = computed(() => product.value?.hyperlink);
const productPrice = computed(() =>
  Intl.NumberFormat(i18n.locale, {
    style: "currency",
    currency: productDetails.value?.currency ?? "USD",
  }).format(productDetails.value?.price ?? 0),
);

const amplitudePayload: ComputedRef<LtkProductProps> = computed(() => ({
  "ltk-id": product.value?.ltkId ?? "",
  "product-id": product.value?.id ?? "",
  "advertiser-name": productDetails.value?.advertiserName ?? "",
  url: product.value?.hyperlink ?? "",
  index: props?.position ?? "",
}));

const impressionPayload = computed(() =>
  createProductImpression(Actions.View, {
    product_id: props.productId,
    promotion_id: product.value?.ltkId ?? "",
    position: props.position,
    creator_id: props.profileId ?? "",
  }),
);

return { __sfc: true,props, i18n, store, productsStore, productDetailsStore, product, productDetails, productImage, productName, productUrl, productPrice, amplitudePayload, impressionPayload }
}

})